export default "__VITE_ASSET__9f7cd478__"